import React, { Component } from 'react';
import PropTypes from 'prop-types';


export const PageNumbersContext = React.createContext({});

export class PageNumbersProvider extends Component {
  static propTypes = {
    /**
     * Параметр идентифицирующий контекст вызова в рамках страницы.
     */
    requestId: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps.requestId !== this.props.requestId) {
      this.resetPageNumbers();
    }
    return true;
  }

  pageNumbers = {};

  incrementPageNumber = blockId => {
    const currentNumber = this.getPageNumber(blockId);
    this.pageNumbers[blockId] = currentNumber + 1;
  };

  getPageNumber = blockId => {
    return this.pageNumbers[blockId] || 1;
  };

  resetPageNumbers = () => {
    Object.keys(this.pageNumbers).forEach(blockId => {
      this.pageNumbers[blockId] = 1;
    });
  };

  /**
   * Храним контекст в сво-ве класса чтобы не создавать новый объект
   * в рендере и тем самым избегаем лишних перерисовок.
   */
  contextProviderValue = {
    incrementPageNumber: this.incrementPageNumber,
    getPageNumber: this.getPageNumber,
  };

  render() {
    return (
      <PageNumbersContext.Provider value={this.contextProviderValue}>
        {this.props.children}
      </PageNumbersContext.Provider>
    );
  }
}


export const withPageNumbers = WrappedComponent => {
  return function PageNumbersConsumer(props) {
    return (
      <PageNumbersContext.Consumer>
        {contextValue => {
          return (
            <WrappedComponent
              {...props}
              {...contextValue}
            />
          );
        }}
      </PageNumbersContext.Consumer>
    );
  };
};
